const debugLog = (message, debugMode, data) => {
  if (debugMode) {
    console.log(message, data && Object.keys(data).length > 0 ? data : "");
  }
};

export { debugLog };
